import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { loadListsForKind } from './useLoadLists'

// Picks a load list for a vehicle or asset. Filters the supplied lists by
// kind, shows the server's "N peers use it" suggestion caption, and falls
// back to a "Create a load list" shortcut when there is nothing to pick.
const LoadListSelect = ({
  kind,
  loadLists,
  value,
  onChange,
  suggestedLoadList,
  label = 'Load list',
  disabled = false,
  size = 'small',
  allowNone = false,
}) => {
  const navigate = useNavigate()
  const options = loadListsForKind(loadLists, kind)

  if (options.length === 0) {
    return (
      <Stack gap={0.5} alignItems="flex-start">
        <Typography variant="caption" color="text.secondary">
          No {kind} load lists exist yet.
        </Typography>
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={(e) => {
            e.stopPropagation()
            navigate('/make-ready-load-lists/new')
          }}
        >
          Create a load list
        </Button>
      </Stack>
    )
  }

  const suggestionSelected =
    suggestedLoadList?._id && value === suggestedLoadList._id
  const peerLabel = suggestedLoadList?.peerLabel || kind

  return (
    <Stack gap={0.5}>
      <FormControl size={size} fullWidth disabled={disabled}>
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          value={value || ''}
          onChange={(e) => onChange(e.target.value || null)}
          onClick={(e) => e.stopPropagation()}
        >
          {allowNone && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {options.map((list) => (
            <MenuItem key={list._id} value={list._id}>
              {list.title}
              {suggestedLoadList?._id === list._id ? ' (suggested)' : ''}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {suggestionSelected && suggestedLoadList.peerCount > 0 && (
        <Typography variant="caption" color="text.secondary">
          Suggested because {suggestedLoadList.peerCount} other {peerLabel}
          {suggestedLoadList.peerCount === 1 ? '' : 's'} use it
        </Typography>
      )}
    </Stack>
  )
}

export default LoadListSelect
